import ApplicationAdapter from './application';

export default class PslfFieldAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
